module.exports = __webpack_public_path__ + "img/award_2025.4f1eeded.jpg";